export const MAIN_CLASS_NAME = 'folder-selector';
export const BUTTON_CLASS_NAME = `${MAIN_CLASS_NAME}__button`;
export const PREFIX_CLASS_NAME = `${BUTTON_CLASS_NAME}__prefix`;
export const POPOVER_CLASS_NAME = `${MAIN_CLASS_NAME}__popover`;
export const CONTENT_CLASS_NAME = `${POPOVER_CLASS_NAME}__content`;
export const EMPTY_CLASS_NAME = `${CONTENT_CLASS_NAME}__empty`;
export const SCROLL_CLASS_NAME = `${CONTENT_CLASS_NAME}__scroll`;
export const SCROLL_ACTIVE_CLASS_NAME = `${SCROLL_CLASS_NAME}_active`;
export const ITEM_CLASS_NAME = `${SCROLL_CLASS_NAME}__item`;

export const SCROLL_ITEM_COUNT = 5;
export const TOOLTIP_MOUSE_DELAY = 0.5;

export const SKELETON_HEIGHT = 16;
export const SKELETON_WIDTH = 100;
